import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';

const TextArea = (_param)=>{
    var { className , disabled , maxLength , onChange , onBlur , placeholder , name , id  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "disabled",
        "maxLength",
        "onChange",
        "onBlur",
        "placeholder",
        "name",
        "id"
    ]);
    const resolvedId = id || name;
    const handleChange = React.useCallback((e)=>{
        !disabled && onChange && onChange(e.currentTarget.value);
    }, [
        disabled,
        onChange
    ]);
    const handleBlur = React.useCallback((e)=>{
        !disabled && onBlur && onBlur(e.currentTarget.value);
    }, [
        disabled,
        onBlur
    ]);
    return /*#__PURE__*/ React.createElement("textarea", swcHelpers.extends({}, rest, {
        name: name,
        id: resolvedId,
        className: classnames('textarea', className),
        disabled: disabled,
        maxLength: maxLength,
        onChange: handleChange,
        onBlur: handleBlur,
        placeholder: placeholder
    }));
};

export { TextArea as default };
//# sourceMappingURL=TextArea.js.map
